import React from 'react'

import { Button, ButtonClassKey, ButtonProps, ButtonTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'

import { Styles } from '@material-ui/styles'

import { AppTheme, withAppStyles } from '../../themes'


type PolymorphicButton = OverridableComponent<ButtonTypeMap>


export const PlainTextButton: PolymorphicButton = withAppStyles({
  root: {
    textTransform: 'none'
  }
} as Styles<AppTheme, ButtonProps, ButtonClassKey>)(Button) as PolymorphicButton


export const RoundedPlainTextButton: PolymorphicButton = withAppStyles<ButtonClassKey>({
  root: {
    textTransform: 'none',
    borderRadius: '2rem',
  }
} as Styles<AppTheme, ButtonProps, ButtonClassKey>)(Button) as PolymorphicButton


export const MassiveRoundedPlainTextButton: PolymorphicButton = withAppStyles<ButtonClassKey>({
  root: {
    textTransform: 'none',
    borderRadius: '4rem',
    fontSize: 22,
    padding: 8,
    paddingLeft: 20,
    paddingRight: 20,
  },
} as Styles<AppTheme, ButtonProps, ButtonClassKey>)(
  (props: ButtonProps) => <Button size='large' {...props} />
) as PolymorphicButton
